import { all } from 'redux-saga/effects'
import user from './user/sagas'
import menu from './menu/sagas'
import settings from './settings/sagas'
import apps from './apps/sagas'
import plans from './plans/sagas'
import billingHistory from './billingHistory/sagas'
import ai from './ai/sagas'
import roles from './roles/sagas'
import teams from './teams/sagas'
import extensions from './extensions/sagas'
import billing from './billing/sagas'
import calls from './calls/sagas'
import apiKeys from './apiKeys/sagas'
import webhooks from './webhooks/sagas'
import users from './users/sagas'
import messages from './messages/sagas'
import groups from './groups/sagas'
import misc from './misc/sagas'
import widgets from './widgets/sagas'
import metrics from './metrics/sagas'
import moderation from './moderation/sagas'
import aiAgents from './aiAgents/sagas'
import appCore from './appCore/sagas'
import conversationExplorer from './conversationExplorer/sagas'
import pinnedConversations from './pinnedConversations/sagas'

export default function* rootSaga() {
  yield all([
    user(),
    menu(),
    settings(),
    apps(),
    plans(),
    billingHistory(),
    ai(),
    roles(),
    teams(),
    extensions(),
    billing(),
    calls(),
    apiKeys(),
    webhooks(),
    users(),
    messages(),
    groups(),
    misc(),
    widgets(),
    metrics(),
    moderation(),
    aiAgents(),
    appCore(),
    conversationExplorer(),
    pinnedConversations(),
  ])
}
